// This is not a specific slice. But these constants used in nested reducers/slices.

const sliceConstants = {
	sectionName: 'customerDashboard',
};

export const { sectionName } = sliceConstants;

export default sliceConstants;
